export default __webpack_public_path__ + "static/media/dv1.de6b1dab.svg";